import Box from "@amzn/meridian/esm/components/box";
import Divider from "@amzn/meridian/esm/components/divider";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import OutlineCard from "../../OutlineCard";
import { THEME_COLOR } from "../../../../styles/colors";

// Code diff panes: tinted label strip over a gray code area.
const CODE_DIFF_PANES = {
  before: { label: "Before", labelColor: "error", backgroundColor: THEME_COLOR.BLUSH, dividerColor: THEME_COLOR.ROSE },
  after: { label: "After", labelColor: "success", backgroundColor: THEME_COLOR.MINT_GREEN, dividerColor: THEME_COLOR.LIGHT_TEAL },
};

// One side of the diff: tinted label strip over the code.
const DiffPane = ({ pane, code }) => (
  <Theme tokens={{ boxBorderRadiusOutline: 12, boxBorderWidth: 0, dividerColor: pane.dividerColor }}>
    <Box type="outline" backgroundColor={pane.backgroundColor}>
      <Row spacingInset="200 300">
        <Text type="b100" color={pane.labelColor}>{pane.label}</Text>
      </Row>
      <Divider />
      <Row spacingInset="300" backgroundColor={THEME_COLOR.MIST_GRAY}>
        <Text type="b200">{code}</Text>
      </Row>
    </Box>
  </Theme>
);

const CodeDiffCard = ({ title, before, after }) => (
  <OutlineCard title={title}>
    {before != null && <DiffPane pane={CODE_DIFF_PANES.before} code={before} />}
    {after != null && <DiffPane pane={CODE_DIFF_PANES.after} code={after} />}
  </OutlineCard>
);

export default CodeDiffCard;
